import * as timbratureActionsType from "../../actions/actionsTypes/timbraturaActionsType";
import {ofType} from "redux-observable";
import {catchError, combineLatestWith, map, switchMap, withLatestFrom} from "rxjs/operators";
import {asyncScheduler, EMPTY, of, scheduled, throwError, mergeMap} from "rxjs";
import {fromPromise} from "rxjs/internal/observable/innerFrom";

import {ENUM_TIMBRATURE, TAB_ENUM_INDIVIDUI_TARGET, TYPE_INSERT} from "../../costanti";
import new_axios_instance from "../../axios_instance";
import {individuoActions, loadingOverlayActions, notifsActions, timbratureActions} from '../../actions';
import {corsoCorsiActions} from '../../slices/corso_corsiSlice';
import {createMessageRequestException} from "../../fanctionUtility";
import {dayJS} from "../../applicationConf";

export const recuperaTimbrature = (actions$, state$) =>
    actions$.pipe(
        ofType(timbratureActionsType.RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_ACTION),
        withLatestFrom(state$),
        switchMap(([{payload: {idCorso, tab}}, state]) => {
            if (dayJS().isBefore(state.corso.corso.dataInizio, 'day')) {
                return EMPTY;
            }

            let requestObservable = fromPromise(
                    new_axios_instance.get(`/v1/timbratura/controllo/corso/${idCorso}/daData/${dayJS().format('YYYY-MM-DD')}/aData/${dayJS().format('YYYY-MM-DD')}/${tab}`)
                ).pipe(
                    map(resp =>{
                        return resp.data
                    }),
                    catchError(err => throwError(() => createMessageRequestException(err)))
                )
                
            return requestObservable.pipe(
                withLatestFrom(state$),
                switchMap(([data, state]) => {

                    const actions = [];
                    const target = state[TAB_ENUM_INDIVIDUI_TARGET[tab].props][TAB_ENUM_INDIVIDUI_TARGET[tab].props];
                    const dataTimbrature = [];
                    const dataTimbratureError = [];

                    if (!data) {
                        return throwError(() => new Error("Errore Generico"));
                    }

                    data.forEach(user => {
                        if (user.timbrature && user.timbrature.length > 0) {
                            user.timbrature.reverse();
                        }
                        dataTimbrature.push({
                            idAnagrafica: user.idAnagrafica,
                            timbrature: user.timbrature ? user.timbrature : [],
                            giustificativi: user.giustificativi ? user.giustificativi : []
                        });

                        if (user.risultati && user.risultati.length > 0) {
                            const individuo = target.find(x => x.idAnagrafica === user.idAnagrafica);
                            if (individuo) {
                                const messageErrorTimbrature = user.risultati.map(error => `${individuo.cognome} ${individuo.nome}: ${error.descrizione}`);
                                dataTimbratureError.push({
                                    idAnagrafica: user.idAnagrafica,
                                    message: messageErrorTimbrature.join(', ')
                                });
                            }
                        }
                    });

                    return scheduled([
                        ...actions,
                        corsoCorsiActions.getParticipantsToTheDateSuccess(data),
                        timbratureActions.ricercaTimbratureSingoloIndividuoEnd(dataTimbrature, dataTimbratureError)
                    ], asyncScheduler);
                })
            );
        }),
        catchError(err => scheduled([
            notifsActions.notifError(createMessageRequestException(err)),
            corsoCorsiActions.getCorsoFail(true)
        ], asyncScheduler))
    );

export const timbraturaManuali = action$ =>
  action$.pipe(
    ofType(timbratureActionsType.ADD_TIMBRATURA_MANUALE_ACTION, timbratureActionsType.ADD_TIMBRATURA_AUTOMATICA_ACTION),
    switchMap(({ payload: { datiTimbratura, tab, type, cbReload } }) =>
      of({ idCorso: datiTimbratura[0].idCorso, tab, type, cbReload }).pipe(
        combineLatestWith(
          fromPromise(
            new_axios_instance.post(
              `/v1/timbratura/inserisci/${type === TYPE_INSERT.AUTOMATICHE ? 'automatica' : 'manuale'}/bulk`,
              {
                idCorso: datiTimbratura[0].idCorso,
                idAnagrafiche: datiTimbratura.map(d => d.idAnagrafica),
                data: datiTimbratura[0].data,
                tipoTimbratura: datiTimbratura[0].tipoTimbratura,
                note: datiTimbratura[0].note,
                tipoUtente: datiTimbratura[0].tipoUtente
              }
            )
          ).pipe(
            map(({ data }) => ({
              data,
              isError: false
            })),
            catchError(err =>
              of({
                error: createMessageRequestException(err),
                isError: true
              })
            )
          )
        ),
        map(([meta, resp]) => {
          const actions = [];

          if (resp.isError) {
            actions.push(notifsActions.notifError(resp.error));
          } else {
            actions.push(
              notifsActions.notifSuccess(
                `Timbrature di ${ENUM_TIMBRATURE[datiTimbratura[0].tipoTimbratura].azione.toLowerCase()} avvenute correttamente n.${datiTimbratura.length} su n.${datiTimbratura.length} individui`
              )
            );
          }
            actions.push(timbratureActions.ricercaTimbratureSingoloIndividuoAction(meta.idCorso, meta.tab));
            actions.push(individuoActions.initIndividuiSelezionati());
            actions.push(loadingOverlayActions.hideLoadingOverlay());
          return actions;
        }),
        mergeMap(actions => actions)
      )
    )
  );



